export default function reducer(state, action) {
    switch (action.type) {
        case "SET_CONTENT":
            return {
                ...state,
                products: action.payload.products,
                productsStatic: action.payload.products,
                possibleResults: action.payload.possibleResults,
                requiredFields: action.payload.requiredFields,
                loadingContent: false
            };
        case "TOGGLE_LOADING_DATA":
            return {
                ...state,
                loadingData: !state.loadingData
            };
        case "SET_PAGINATION":
            return {
                ...state,
                pagination: action.payload.pagination
            };
        case "SET_DATA":
            return {
                ...state,
                data: action.payload.data
            };
        case "SET_DETAIL_OBJECT":
            return {
                ...state,
                detailObject: action.payload.detailObject,
                data: action.payload.data ?? state.data,
                loadingDetail: action.payload.loadingDetail
            };
        case "SET_HISTORICAL":
            return {
                ...state,
                historical: {
                    toHistoricalObject: 'toHistoricalObject' in action.payload ? action.payload.toHistoricalObject : state.historical.toHistoricalObject,
                    toHistoricalLoading: 'toHistoricalLoading' in action.payload ? action.payload.toHistoricalLoading : state.historical.toHistoricalLoading,
                    toHistoricalMessage: 'toHistoricalMessage' in action.payload ? action.payload.toHistoricalMessage : state.historical.toHistoricalMessage
                }
            };
        case "SET_FORM_FIELDS":
            return {
                ...state,
                formFields: action.payload.formFields,
                detailFields: action.payload.detailFields
            };
        default:
            throw new Error();
    }
}
